import { Button } from 'react-bootstrap';
import { fonts } from './fonts';

export interface FontButtonProps {
  className: { [key: string]: string };
  selectedTheme: string;
  handleFontChange({ target }: any): void;
}

export const FontButton: React.FC<FontButtonProps> = ({
  className,
  selectedTheme,
  handleFontChange,
}) => (
  <div className={className.fontFace}>
    {fonts.map((font) => (
      <div key={font.name}>
        <div style={{ padding: '5px' }}>
          <Button
            id={font.family}
            className={className.btn}
            name={selectedTheme}
            onClick={handleFontChange}
          >
            {font.name}
          </Button>
        </div>
      </div>
    ))}
  </div>
);
